import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Context as HelperContext } from '../../../providers/HelperContextProvider';
import ResponsiveWebstoreModal from './ResponsiveWebstoreModal';
import WsProductInformationDisplay from './sections/productInformation/WsProductInformationDisplay';
import { config as defaultProductDisplayConfig } from './pages/wsDefaultProductDisplayConfig';

const AddWebstoreProductToCartModal = ({
  baseStoreUrl,
  mediaQueries,
  editModeEnabled,
  onNavigate,
  ecomStoreTheme,
  pathname,
  colorSchemes,
  themeConfig
}) => {
  const {
    state: helperState,
    toggleWebstoreAddProductToCartModal
  } = useContext(HelperContext);
  const { ecomStoreProduct } = helperState.webstore.addProductToCartModal;
  const { isTabletOrSmaller } = mediaQueries;

  useEffect(() => {
    if (helperState.webstore.addProductToCartModal.isOpen) {
      // eslint-disable-next-line no-use-before-define
      onClose();
    }
  }, [pathname]);

  const onClose = () => {
    toggleWebstoreAddProductToCartModal({
      isOpen: false,
      ecomStoreProduct:
        helperState.webstore.addProductToCartModal.ecomStoreProduct
    });
  };

  return (
    <ResponsiveWebstoreModal
      alignModal={isTabletOrSmaller ? 'end' : 'center'}
      editModeEnabled={editModeEnabled}
      isOpen={helperState.webstore.addProductToCartModal.isOpen}
      mediaQueries={mediaQueries}
      noHeader
      onClose={onClose}
      radius={0}
      size={1200}
    >
      <WsProductInformationDisplay
        baseStoreUrl={baseStoreUrl}
        blocks={defaultProductDisplayConfig.blocks.filter(
          (b) => !b.isVisible || b.isVisible({ isPreview: true })
        )}
        colorSchemes={colorSchemes}
        config={defaultProductDisplayConfig}
        ecomStoreProduct={ecomStoreProduct}
        ecomStoreTheme={ecomStoreTheme}
        editModeEnabled={editModeEnabled}
        isPreview
        mediaQueries={mediaQueries}
        onAddOrUpdateCallback={onClose}
        onEditCancel={onClose}
        onNavigate={onNavigate}
        pathname={pathname}
        themeConfig={themeConfig}
      />
    </ResponsiveWebstoreModal>
  );
};

AddWebstoreProductToCartModal.propTypes = {
  baseStoreUrl: PropTypes.string,
  colorSchemes: PropTypes.array,
  ecomStoreTheme: PropTypes.object,
  editModeEnabled: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onNavigate: PropTypes.func,
  pathname: PropTypes.string,
  themeConfig: PropTypes.object
};

export default AddWebstoreProductToCartModal;
